import { ConsoleSqlOutlined } from '@ant-design/icons';
import {
  Typography, VertButton, VertModal,
} from '@vertem-core/vertice-ds';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';



const VertemGiftInformativeModal = ({ isOpen, onCancel }) => {

  const { ballonsByParticipant, availableBallons } = useSelector(state => state.VertemGift);

  const unredeemedItems = ballonsByParticipant.filter(balloon => balloon.status === 2);
  const hasUnredeemedPrizes = unredeemedItems.length > 0;
  const hasAvailableBalloons = availableBallons.length > 0;

  const messages = {
    balloons: 'Você ainda não estourou todos os seus balões da promoção de aniversário do Acessa Agro.',
    prizes: 'Você ainda não resgatou seu prêmio da promoção de aniversário do Acessa Agro.'
  };

  const messageKey = hasUnredeemedPrizes && hasAvailableBalloons ? 'balloons' :
    hasUnredeemedPrizes ? 'prizes' :
      hasAvailableBalloons ? 'balloons' : null;

  const message = messages[messageKey];

  return (
    <VertModal
      onCancel={() => {
        onCancel();
      }}
      open={isOpen}
      centered
      closable
      footer={(
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            padding: '0 27px',
          }}
        >
          <Link className="col-12" to="/campanhas">
            <VertButton type="highlight" className="col-12">
              <Typography.Text
                style={{
                  fontSize: '16px', lineHeight: '24px', color: 'white', fontWeight: 'regular',
                }}
                strong
              >
                Continuar
              </Typography.Text>
            </VertButton>
          </Link>
        </div>
      )}
    >
      <div style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        padding: '0 27px',
      }}
      >
        <Typography.Text
          style={{ fontSize: '18px', lineHeight: '28px', marginTop: '24px' }}
          strong
        >
          Aniversário Acessa Agro
        </Typography.Text>
        <Typography.Text
          style={{
            textAlign: 'center',
            marginTop: '15px',
            fontSize: '14px',
            lineHeight: '20px',
          }}
        >
          {message}
        </Typography.Text>
      </div>
    </VertModal>
  );
};

export default VertemGiftInformativeModal;
